import { render, staticRenderFns } from "./Dairy_quests.vue?vue&type=template&id=6a48b42e&scoped=true&"
import script from "./Dairy_quests.vue?vue&type=script&lang=js&"
export * from "./Dairy_quests.vue?vue&type=script&lang=js&"
import style0 from "./Dairy_quests.vue?vue&type=style&index=0&id=6a48b42e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a48b42e",
  null
  
)

export default component.exports